import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import NavBar from './NavBar';
import { BagDrawer } from '../studio/Commerce';
import SiteFooter from './SiteFooter';
import SearchDrawer from './SearchDrawer';
import { SearchProvider } from '../searchContext';

const StorefrontLayout = ({ children, className = '' }) => {
    const contentRef = useRef(null);
    const { pathname } = useLocation();

    useEffect(() => {
        const headings = contentRef.current.querySelectorAll(
            '.aboutPageTitle, .aboutListTitle, .shopCollectionHeading, .shopSectionTitle, .eventsTitle, .simplePageTitle, .homeIntro'
        );
        const observer = typeof IntersectionObserver === 'undefined' ? null : new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('inkRevealVisible');
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.2 });
        headings.forEach((heading) => {
            heading.classList.add('inkReveal');
            if (observer) observer.observe(heading);
            else heading.classList.add('inkRevealVisible');
        });
        return () => {
            observer?.disconnect();
            headings.forEach((heading) => heading.classList.remove('inkReveal', 'inkRevealVisible'));
        };
    }, [pathname]);

    return (
        <SearchProvider>
            <div className={`storefront ${className}`.trim()}>
                <NavBar />
                <div className="pageEnter" ref={contentRef} key={pathname}>{children}</div>
                {className.includes('galleryPageWrap') ? null : <SiteFooter />}
                <div className="ds-app"><BagDrawer /></div>
                <SearchDrawer />
            </div>
        </SearchProvider>
    );
};

export default StorefrontLayout;
